<div class="mobile_version-backbutton"><a onclick="history.back()" class="mobile-header"><span  ><img  
    src="../../../assets/images/tournament/backBtn.svg" alt=""></span>Blogs </a></div>
<div class="topTitle">
  <h2>Blogs</h2>
</div>
<section class="artical-section" id="featuredArticlesSection">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="slider-main">
          <div class="blogsListList" *ngFor="let blog of blogContent">
            <div class="main-slider">
              <div class="news-image">
                <img [defaultImage]="'assets/img/lazyload/lazyLoad.png'" [lazyLoad]="blog?.blogImage[0]?.image_src"
                  alt="">
              </div>
              <div class="main-text-div-button">
                <div class="text-div">
                  <div class="main-title">
                    <h4> {{blog.title}}</h4>
                  </div>
                  <div class="paragraph">
                    <p> {{blog.shortdescription}}</p>
                  </div>
                </div>
                <div class="buttonDiv">
                  <button routerLink="/blog/{{blog.id}}">
                    <img src="../../../assets/images/home-page/articalarrow.svg " alt="">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>